import { Control, Controller } from "react-hook-form";
import { DatePicker, Form } from "antd";

interface DatePickerControlledInputProps {
    control: Control<any, any>;
    inputName: string;
    label: string;
    className?: string;
}

export const DatePickerControlledInput = ({ inputName, control, label, className, ...rest }: DatePickerControlledInputProps) => {

    return (
        <Form.Item label={label} className={className} labelCol={{ span: 24 }}>
            <Controller
                name={inputName}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <DatePicker
                        {...rest}
                        format="DD/MM/YYYY"
                        onChange={(date) => onChange(date)}
                        value={value}
                        style={{ width: '100%' }}
                        placeholder={`Selecione ${label.toLocaleLowerCase()}`}
                    />
                )}
            />
        </ Form.Item>
    );
};